import React, { ReactElement } from "react";
import EmptyStarImage from "../../../../assets/icons/icon-cool/outline/Star.svg";
import FilledStarImage from "../../../../assets/icons/icon-cool/filled/Star.svg";
import Icon from "../../../Icon";
import { StarContainer } from "./styles";

interface ComponentProps {
  value: number;
  totalStars?: number;
}

const Component = ({ value, totalStars = 5 }: ComponentProps) => {
  const renderStars = () => {
    const stars: ReactElement[] = [];
    for (let i = 1; i <= totalStars; i++) {
      const starImage = i <= value ? FilledStarImage : EmptyStarImage;
      stars.push(<Icon key={i} icon={starImage} size="12px" color="#f1f4f9" />);
    }
    return stars;
  };

  return <StarContainer>{renderStars()}</StarContainer>;
};

export default Component;
